import type { IUserInfo } from '../../domain';
import { ApiBaseService } from '../api-base-service';

export class SecurityApiService extends ApiBaseService {
    constructor(context = '/security') {
        super(`${context}`);
    }

    async fetchUserInfo(): Promise<IUserInfo> {
        const response = await this.http.get<IUserInfo>('/current-user-info');

        if (response.status !== 200) {
            throw new Error('Received non valid status code');
        }

        return response.data;
    }
}
